import React, { PureComponent } from "react";
import styles from "./actionLog.module.less"
import PropTypes from "prop-types";
import { Spin, Timeline, Empty } from "antd"
import { connect } from "dva";
import InfiniteScroll from 'react-infinite-scroller';
import classnames from 'classnames';
import * as DICT from "@/utils/dict"
import http from "@/http"
import { handleAlarmContext2Props } from "../../../../decorator/context2Props"
import ReactResizeDetector from 'react-resize-detector';
import Tag from "@/components/Tag";

const HttpAction = http.tokiot.device.actionLog;

class ActionLog extends PureComponent {
    divRef = React.createRef();
    state = {
        actionList: [],
        loading: false,
        pageNumber: 0,
        pageTotal: 0,
    };

    static contextTypes = {
        handleAlarm: PropTypes.func,
    }

    componentDidMount() {
        this.loadEventList();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.refreshKey != this.props.refreshKey) {
            this.loadEventList();
        }
    }

    loadEventList = (page = 1, size = 10) => {
        const { deviceInfo } = this.props;
        let { actionList, pageTotal } = this.state;
        if (deviceInfo && deviceInfo.id && deviceInfo.id.length > 0 && (page === 1 || page <= pageTotal)) {
            this.setState({ loading: true });
            let data = {
                deviceId: deviceInfo.id,
                page: page,
                size: size,
            };
            HttpAction.list(data).then((ret) => {
                if (ret && ret.rows && ret.rows.length > 0) {
                    if (ret.pageNumber == 1)
                        actionList = [];
                    this.setState({ actionList: actionList.concat(ret.rows), loading: false, pageNumber: ret.pageNumber, pageTotal: ret.pageTotal });
                } else {
                    this.setState({ loading: false, pageTotal: 0 });
                }
            });
        }
    }

    typeChange = (type) => {
        this.setState({ selectType: type });
    }

    render() {
        const { actionList, pageNumber, loading } = this.state;
        return (
            <ReactResizeDetector handleHeight>
                {({ width, height }) => {
                    let style = {};
                    if (height > 0) {
                        style.height = height;
                    }
                    return (
                        <div className={styles.main} >
                            <Spin className={styles.span} spinning={loading} >
                                {actionList && actionList.length > 0 ?
                                    <div className={styles.alarmListDiv} style={style}>
                                        <InfiniteScroll
                                            initialLoad={false}
                                            pageStart={0}
                                            loadMore={e => { this.loadEventList(pageNumber + 1, 10) }}
                                            hasMore={!loading}
                                            useWindow={false}
                                        >
                                            <Timeline>
                                                {
                                                    actionList.map(action => {
                                                        let color = (action.iothubState && action.iothubState.length > 0 && styles[action.iothubState.toUpperCase()]) ? styles[action.iothubState.toUpperCase()] : `#AAAAAA`;
                                                        let params = {};
                                                        if (action.params && action.params.length > 0) {
                                                            params = JSON.parse(action.params);
                                                        }
                                                        let iothubState = ``;
                                                        switch (action.iothubState) {
                                                            case `Success`:
                                                                iothubState = `成功`;
                                                                break;
                                                            case `Failed`:
                                                                iothubState = `失败`;
                                                                break;
                                                            case `Discard`:
                                                                iothubState = `丢弃`;
                                                                break;
                                                            case `Pendding`:
                                                                iothubState = `发送中`;
                                                                break;
                                                            case `Wait`:
                                                                iothubState = `等待`;
                                                                break;
                                                            default:
                                                                break;
                                                        }

                                                        return (
                                                            <Timeline.Item className={styles.timelineItem} color={color}>
                                                                <div className={styles.alarmMainDiv}>
                                                                    <div className={styles.alarmDiv} >
                                                                        <div className={styles.alarmInfo}>
                                                                            <span className={styles.text}>{action.createdTime}</span>
                                                                            <div className={styles.row}>
                                                                                <span className={styles.text}>{action.actionUser}</span>
                                                                                <span className={styles.text}>{action.actionName}</span>
                                                                            </div>
                                                                            {action.iothubResult ? <span className={styles.text}>{action.iothubResult}</span> : ``}
                                                                            {action.remark ? <span className={styles.text}>{action.remark}</span> : ``}
                                                                            <div className={styles.title} >
                                                                                <Tag color={action.iothubState}>{iothubState}</Tag>
                                                                                <Tag color={`GRAY6`}>
                                                                                    {DICT.getValue(`DEVICE_ACTION_EXECUTE_TYPE`, action.executeType)}
                                                                                </Tag>
                                                                            </div>
                                                                        </div>
                                                                        {params && params.length > 0 ?
                                                                            <div className={styles.paramList}>
                                                                                {params.map(item => {
                                                                                    return (
                                                                                        <div className={styles.paramDiv}>
                                                                                            <span className={styles.name}>{item.name} : </span>
                                                                                            <span className={styles.value}>{item.value}</span>
                                                                                        </div>
                                                                                    )
                                                                                })}
                                                                            </div>
                                                                            : ``}
                                                                    </div>
                                                                </div>
                                                            </Timeline.Item>
                                                        )
                                                    })
                                                }
                                            </Timeline>
                                        </InfiniteScroll>
                                    </div>
                                    :
                                    <Empty className={styles.empty} image={Empty.PRESENTED_IMAGE_SIMPLE} description={`暂无数据`} />
                                }
                            </Spin>
                        </div>
                    )
                }}
            </ReactResizeDetector>
        )
    }
}
export default ActionLog